<section class="container position-relative">
       <section>
        <div *ngIf=" memberEmailInfo && memberEmailInfo.distributorInfo" class="distributorInformation text-right absolute-right mt-10">
            <div *ngIf="memberEmailInfo.distributorInfo.name" class="bold header-font color-black distributor-name ">
                {{memberEmailInfo.distributorInfo | displayNameFormat}}
            </div>
            <div *ngIf="memberEmailInfo.distributorInfo.displayName && memberEmailInfo.distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                <span>{{memberEmailInfo.distributorInfo.displayName | titlecase}}</span>
              </div>
            <div class="font14">
                <a *ngIf="memberEmailInfo.distributorInfo.distributorId"><i class="fa fa-copy" [copyToClipboard]="memberEmailInfo.distributorInfo.distributorId"></i></a>
                <span class="color-black" *ngIf="memberEmailInfo.distributorInfo.distributorId">{{memberEmailInfo.distributorInfo.distributorId |distributorIdFormat}}</span>
                <span *ngIf="memberEmailInfo.distributorInfo.level"> | {{memberEmailInfo.distributorInfo.level}}</span>
            </div>
        </div>
       </section>
    <div class="row">
        <div class="col-sm-2 wt-12">
            <strong> {{'store.Email' |translate | translateKey}}</strong>
        </div>
        <div class="col-sm-1 wt-6">:</div>
        <div class="col-sm-9" style="width: 41%;">
            <span *ngIf="memberEmailView && memberEmailView.sentToEmailId">{{memberEmailView.sentToEmailId}}</span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2 wt-12">
            <strong> {{'email-view.Sent Date' |translate | translateKey}}</strong>
        </div>
        <div class="col-sm-1 wt-6">:</div>
        <div class="col-sm-9" style="width: 41%;">
            <span *ngIf="memberEmailView && memberEmailView.sentDate">{{memberEmailView.sentDate}}</span>
        </div>
    </div>
   
    <div class="row">
        <div class="col-sm-2 wt-12">
          <strong>{{'email-view.Subject' |translate | translateKey}}</strong>
        </div>
        <div class="col-sm-1 wt-6">:</div>
        <div class="col-sm-9" style="width: 41%;">
            <span *ngIf="memberEmailView && memberEmailView.subject">{{memberEmailView.subject}}</span>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-sm-12" *ngIf="memberEmailView && memberEmailView.contentHtmlPart"> 
            <div class = "border border-secondary">
            <div [embedHTML]="memberEmailView.contentHtmlPart |sanitizeHtml"> </div>
             </div>
        </div>
    </div>
   
    <div class="col-sm-12 resend-mail">
            <button  *ngIf="!disableResend" (click)="memberResendMail()" class="flot-left btn blue-button">
                {{'email-view.Resend' |translate | translateKey}}
            </button>
     </div>

    <section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-email-view.component.html